<div class="sponsor-create component-viewer">

  <h1 class="mat-h1 page-title">Add sponsor</h1>

  <p class="page-subtitle mat-body-1" *ngIf="canCreateSponsor && selectedIteration">

    Record a sponsor for the selected outing iteration.

  </p>



  <mat-card *ngIf="canCreateSponsor && selectedIteration" class="sponsor-card">

    <mat-card-header>

      <mat-card-title>Sponsor information</mat-card-title>

      <mat-card-subtitle>

        <span class="subtitle-line">

          <mat-icon class="subtitle-icon" aria-hidden="true">event</mat-icon>

          {{ selectedIteration.startDate | date: 'EEEE, MMM d, y' }} at {{ selectedIteration.startDate | date: 'shortTime' }}

        </span>

      </mat-card-subtitle>

    </mat-card-header>



    <mat-divider />



    <form [formGroup]="form" (ngSubmit)="onSubmit(form)">

      <mat-card-content>

        <mat-progress-bar mode="indeterminate" *ngIf="isLoading" class="progress-bar" />



        <section class="form-section" aria-label="Contact information">

          <h2 class="section-heading mat-subtitle-2">

            <mat-icon class="section-heading__icon" aria-hidden="true">person</mat-icon>

            Contact

          </h2>

          <div class="form-grid">

            <mat-form-field appearance="outline" class="full-width">

              <mat-label>Name</mat-label>

              <input matInput formControlName="name" autocomplete="name" />

              <mat-error *ngIf="form.get('name')?.errors?.required">Name is required</mat-error>

              <mat-error *ngIf="form.get('name')?.errors?.validationErrors">

                {{ form.get('name')?.errors?.validationErrors }}

              </mat-error>

            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">

              <mat-label>Contact email</mat-label>

              <input matInput type="email" formControlName="contactEmail" autocomplete="email" />

              <mat-error *ngIf="form.get('contactEmail')?.errors?.required">Email is required</mat-error>

              <mat-error *ngIf="form.get('contactEmail')?.errors?.email">Enter a valid email address</mat-error>

              <mat-error *ngIf="form.get('contactEmail')?.errors?.validationErrors">

                {{ form.get('contactEmail')?.errors?.validationErrors }}

              </mat-error>

            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">

              <mat-label>Company</mat-label>

              <input matInput formControlName="company" autocomplete="organization" />

            </mat-form-field>

          </div>

        </section>



        <mat-divider />



        <section class="form-section" aria-label="Sponsorship details">

          <h2 class="section-heading mat-subtitle-2">

            <mat-icon class="section-heading__icon" aria-hidden="true">volunteer_activism</mat-icon>

            Sponsorship

          </h2>

          <div class="form-grid">

            <mat-form-field appearance="outline" class="full-width">

              <mat-label>Sponsor type</mat-label>

              <mat-select formControlName="type">

                <mat-option *ngFor="let opt of sponsorTypeOptions" [value]="opt.value">{{ opt.label }}</mat-option>

              </mat-select>

            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">

              <mat-label>Amount</mat-label>

              <span matPrefix>$&nbsp;</span>

              <input matInput type="number" formControlName="amount" min="0" step="0.01" />

            </mat-form-field>

          </div>

          <div class="option-row">

            <mat-slide-toggle formControlName="requestReceipt" color="primary">

              Request receipt

            </mat-slide-toggle>

          </div>

        </section>



        <mat-divider />



        <section class="form-section" aria-label="Notes">

          <h2 class="section-heading mat-subtitle-2">

            <mat-icon class="section-heading__icon" aria-hidden="true">notes</mat-icon>

            Notes

          </h2>

          <div class="form-grid form-grid--single">

            <mat-form-field appearance="outline" class="full-width">

              <mat-label>Additional notes</mat-label>

              <textarea matInput formControlName="notes" rows="4"></textarea>

            </mat-form-field>

          </div>

        </section>

      </mat-card-content>



      <mat-card-actions align="end" class="form-actions">

        <button mat-stroked-button type="button" routerLink="/outing-management/administration/sponsors">

          Cancel

        </button>

        <button mat-flat-button color="primary" type="submit" [disabled]="form.invalid || isLoading">

          Save sponsor

        </button>

      </mat-card-actions>

    </form>

  </mat-card>



  <mat-card *ngIf="!canCreateSponsor" class="empty-state-card">

    <mat-card-content class="empty-state">

      <mat-icon class="empty-state__icon" aria-hidden="true">event_busy</mat-icon>

      <h2 class="mat-h3 empty-state__title">Cannot add sponsor</h2>

      <p class="mat-body-1 empty-state__text">

        Select an outing and iteration from the header before adding a sponsor.

      </p>

    </mat-card-content>

  </mat-card>

</div>

